import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'diamond', 'Diamond', [["path",{"d":"M6 5h12l3 5l-8.5 9.5a.7 .7 0 0 1 -1 0l-8.5 -9.5l3 -5"}],["path",{"d":"M10 12l-2 -2.2l.6 -1"}]]);